import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { ButtonProps } from './button.models';
import { useStyles } from './button.styles';

export const Button = ({
  children,
  to,
  style,
  rootClasses,
  textClasses,
  ariaLabel,
  onClick,
  hideText,
  fullWidth,
  startIcon,
  isUnderline,
  testId,
  isExternalLink,
  ...rest
}: ButtonProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      {to ? (
        <a
          {...rest}
          href={to}
          target={isExternalLink ? '_blank' : '_self'}
          className={cx(classes.root, style, rootClasses, {
            [classes.fullWidth]: fullWidth,
            [classes.isUnderline]: isUnderline,
          })}
          aria-label={ariaLabel && intl.formatMessage({ id: ariaLabel })}
          data-testid={testId}
        >
          {startIcon}
          {!hideText && <span className={textClasses}>{children}</span>}
        </a>
      ) : (
        <button
          {...rest}
          aria-label={ariaLabel && intl.formatMessage({ id: ariaLabel })}
          className={cx(classes.root, style, rootClasses, {
            [classes.fullWidth]: fullWidth,
            [classes.isUnderline]: isUnderline,
          })}
          onClick={onClick}
          data-testid={testId}
        >
          {startIcon}
          {!hideText && <span className={textClasses}>{children}</span>}
        </button>
      )}
    </>
  );
};
